<!--Loading Spinner-->
<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>

<!-- Main content -->
<div class="content">
  <div class="container-fluid">
    <div class="row" style="padding-top: 5px;">
      <div class="col-12 col-sm-6 col-md-3">
        <a routerLink="/suppliers/stock-list">
        <div class="info-box">
          <span class="info-box-icon bg-info elevation-1"><i class="fa fa-hourglass-end"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Vehicles In Japan Stock</span>
            <span class="info-box-number">
             {{noOfVehiclesInSupplierStock}}
            </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        </a>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
      <div class="col-12 col-sm-6 col-md-3">
        <a routerLink="/stock-overview/stock-en-route">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-primary elevation-1"><i class="fas fa-ship"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Vehicles En route</span>
              <span class="info-box-number">{{noOfVehiclesEnroute}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </a>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->

      <!-- fix for small devices only -->
      <div class="clearfix hidden-md-up"></div>

      <div class="col-12 col-sm-6 col-md-3">
        <a routerLink="/stock-overview/stock-at-cfs">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-success elevation-1"><i class="fas fa-anchor"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Vehicles At CFS</span>
              <span class="info-box-number">{{noOfVehiclesAtCfs}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </a>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
      <div class="col-12 col-sm-6 col-md-3">
        <a href="#" (click)="getWeeklySales()"> <!--Open a popup-->
          <div class="info-box mb-3">
            <span class="info-box-icon bg-warning elevation-1"><i class="far fa-money-bill-alt"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Total Units Sold This Week</span>
              <span class="info-box-number">{{noOfVehiclesSoldThisWeek}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </a>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
    <div class="row">
      <div class="col-lg-6">
          <div class="card card-success card-outline">
              <div class="card-header d-flex align-items-center flex-wrap">
                <h5 class="m-0">Incoming Transfers</h5>
                <div class="btn-group btn-group-sm ml-auto" role="group" aria-label="Incoming transfers filter">
                  <button type="button"
                          class="btn"
                          [class.btn-success]="incomingFilter === 'all'"
                          [class.btn-outline-success]="incomingFilter !== 'all'"
                          (click)="setIncomingFilter('all')">
                    All <span class="badge badge-light">{{ incomingAllCount }}</span>
                  </button>
                  <button type="button"
                          class="btn"
                          [class.btn-danger]="incomingFilter === 'overdue'"
                          [class.btn-outline-danger]="incomingFilter !== 'overdue'"
                          (click)="setIncomingFilter('overdue')">
                    Overdue <span class="badge badge-light">{{ incomingOverdueCount }}</span>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8"></div>
                  <div class="col-md-4">
                    <div class="row">
                        <div class="col" style="margin: 2px 5px;">
                            <input type="text" class="form-control" placeholder="Type here to search..." (input)="incomingOnSearchTextChange($event)">
                        </div>
                    </div>
                  </div>
                </div>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Make/Model</th>
                      <th>Chassis No.</th>
                      <th>Dispatched On</th>
                      <th>From</th>
                      <th>Driver</th>
                      <th>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let t of filteredIncomingTransfers | searchTransferSummaries: incomingSearchText | paginate: { itemsPerPage: 5, currentPage: incoming_page, totalItems: incoming_count,id: 'incoming_transfers' }">
                      <td>{{ t.makeModel }}</td>
                      <td>{{ t.chassisNo }}</td>
                      <td>{{ t.dispatchedOn }}</td>
                      <td>{{ t.from }}</td>
                      <td>{{ t.driver }}</td>
                      <td>{{ t.dispatchedOn | timeAgo }}</td>
                    </tr>
                    <tr *ngIf="filteredIncomingTransfers.length === 0">
                      <td colspan="6" class="text-center text-muted">No incoming transfers found!</td>
                    </tr>
                  </tbody>
                </table>
                <pagination-controls (pageChange)="incomingPageChangeEvent($event)" id="incoming_transfers"></pagination-controls>
              </div>
         </div>

        <div class="card card-success card-outline">
          <div class="card-header d-flex align-items-center flex-wrap">
            <h5 class="m-0">This Week's Transfers</h5>
            <div class="btn-group btn-group-sm ml-auto" role="group" aria-label="This week's transfers filter">
              <button type="button"
                      class="btn"
                      [class.btn-success]="weekFilter === 'all'"
                      [class.btn-outline-success]="weekFilter !== 'all'"
                      (click)="setWeekFilter('all')">
                All <span class="badge badge-light">{{ weekAllCount }}</span>
              </button>
              <button type="button"
                      class="btn"
                      [class.btn-warning]="weekFilter === 'pending'"
                      [class.btn-outline-warning]="weekFilter !== 'pending'"
                      (click)="setWeekFilter('pending')">
                Pending <span class="badge badge-light">{{ weekPendingCount }}</span>
              </button>
              <button type="button"
                      class="btn"
                      [class.btn-info]="weekFilter === 'completed'"
                      [class.btn-outline-info]="weekFilter !== 'completed'"
                      (click)="setWeekFilter('completed')">
                Completed <span class="badge badge-light">{{ weekCompletedCount }}</span>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
                <div class="col-md-8"></div>
                <div class="col-md-4">
                  <div class="row">
                      <div class="col" style="margin: 2px 5px;">
                          <input type="text" class="form-control" placeholder="Type here to search..." (input)="weekOnSearchTextChange($event)">
                      </div>
                  </div>
                </div>
              </div>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Make/Model</th>
                  <th>Chassis No.</th>
                  <th>Dispatched On</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Driver</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let t of filteredWeekTransfers | searchTransferSummaries: weekSearchText | paginate: { itemsPerPage: 5, currentPage: week_page, totalItems: week_count,id: 'week_transfers' }">
                  <td>{{ t.makeModel }}</td>
                  <td>{{ t.chassisNo }}</td>
                  <td>{{ t.dispatchedOn }}</td>
                  <td>{{ t.from }}</td>
                  <td>{{ t.to }}</td>
                  <td>{{ t.driver }}</td>
                  <td>{{ t.dispatchedOn | timeAgo }}</td>
                </tr>
                <tr *ngIf="filteredWeekTransfers.length === 0">
                  <td colspan="7" class="text-center text-muted">No transfers found</td>
                </tr>
              </tbody>
            </table>
            <pagination-controls (pageChange)="weekPageChangeEvent($event)" id="week_transfers"></pagination-controls>
          </div>
        </div><!-- /.card -->
      </div>
      <!-- /.col-md-6 -->
      <div class="col-lg-6">
        <div class="card card-success card-outline">
          <div class="card-header d-flex align-items-center flex-wrap">
            <h5 class="m-0">Outgoing Transfers</h5>
            <div class="btn-group btn-group-sm ml-auto" role="group" aria-label="Outgoing transfers filter">
              <button type="button"
                      class="btn"
                      [class.btn-success]="outgoingFilter === 'all'"
                      [class.btn-outline-success]="outgoingFilter !== 'all'"
                      (click)="setOutgoingFilter('all')">
                All <span class="badge badge-light">{{ outgoingAllCount }}</span>
              </button>
              <button type="button"
                      class="btn"
                      [class.btn-danger]="outgoingFilter === 'overdue'"
                      [class.btn-outline-danger]="outgoingFilter !== 'overdue'"
                      (click)="setOutgoingFilter('overdue')">
                Overdue <span class="badge badge-light">{{ outgoingOverdueCount }}</span>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div class="row">
                    <div class="col" style="margin: 2px 5px;">
                        <input type="text" class="form-control" placeholder="Type here to search..." (input)="outgoingOnSearchTextChange($event)">
                    </div>
                </div>
              </div>
            </div>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Make/Model</th>
                  <th>Chassis No.</th>
                  <th>Dispatched On</th>
                  <th>To</th>
                  <th>Driver</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let t of filteredOutgoingTransfers | searchTransferSummaries: outgoingSearchText | paginate: { itemsPerPage: 5, currentPage: outgoing_page, totalItems: outgoing_count,id: 'outgoing_transfers' }">
                  <td>{{ t.makeModel }}</td>
                  <td>{{ t.chassisNo }}</td>
                  <td>{{ t.dispatchedOn }}</td>
                  <td>{{ t.to }}</td>
                  <td>{{ t.driver }}</td>
                  <td>{{ t.dispatchedOn | timeAgo }}</td>
                </tr>
                <tr *ngIf="filteredOutgoingTransfers.length === 0">
                  <td colspan="6" class="text-center text-muted">No outgoing transfers found</td>
                </tr>
              </tbody>
            </table>
            <pagination-controls (pageChange)="outgoingPageChangeEvent($event)" id="outgoing_transfers"></pagination-controls>
          </div>
        </div>

        <div class="card card-success card-outline">
          <div class="card-header d-flex align-items-center flex-wrap">
            <h5 class="m-0">Weekly Sales Performance</h5>
            <div class="btn-group btn-group-sm ml-auto" role="group" aria-label="Weekly sales performance filter">
              <button type="button"
                      class="btn"
                      [class.btn-success]="salesPeriodFilter === 'thisWeek'"
                      [class.btn-outline-success]="salesPeriodFilter !== 'thisWeek'"
                      (click)="setSalesPeriod('thisWeek')">This Week</button>
              <button type="button"
                      class="btn"
                      [class.btn-success]="salesPeriodFilter === 'lastWeek'"
                      [class.btn-outline-success]="salesPeriodFilter !== 'lastWeek'"
                      (click)="setSalesPeriod('lastWeek')">Last Week</button>
            </div>
          </div>
          <div class="card-body" style="width: 600px;height:400px;">
            <canvas id="WeeklySalesChart">{{ weekly_sales_chart }}</canvas>
          </div>
        </div>
      </div>
      <!-- /.col-md-6 -->
    </div>
    <!-- /.row -->
  </div><!-- /.container-fluid -->
</div>
<!-- /.content -->

<!-- Weekly Sales Modal -->
<div class="modal fade" #WeeklySales tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content" style="overflow-x: auto; overflow-y: auto; white-space: nowrap;">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" *ngIf="salesPeriodFilter=='thisWeek'">Units Sold This Week</h5>
        <h5 class="modal-title" id="exampleModalLabel" *ngIf="salesPeriodFilter=='lastWeek'">Units Sold Last Week</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="row">
        <div class="col-md-8"></div>
        <div class="col-md-4">
          <div class="row">
              <div class="col" style="margin: 2px 5px;">
                  <input type="text" class="form-control" placeholder="Search by Chassis Number" (input)="weeklySalesOnSearchTextChange($event)">
              </div>
          </div>
        </div>
      </div>
      <table id="example1" class="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th>DATE</th>
            <th>DELIVERY NO.</th>
            <th>MAKE</th>
            <th>MODEL</th>
            <th>CHASSIS NO.</th>
            <th>COLOUR</th>
            <th>CUSTOMER NAME</th>
            <th>DELIVERED BY</th>
          </tr>
        </thead>
        <tr *ngFor="let unit of weekly_sales | searchVehicle: weeklySalesSearchText | paginate: { itemsPerPage: 10, currentPage: weekly_sales_page, totalItems: weekly_sales_count, id: 'weekly_sales' }">
          <td>{{unit.sales_date | date: 'dd-MM-yyyy'}}</td>
          <td>{{unit.delivery_no}}</td>
          <td>{{unit.make}}</td>
          <td>{{unit.model}}</td>
          <td>{{unit.chassis_no}}</td>
          <td>{{unit.colour}}</td>
          <td>{{unit.customer_name}}</td>
          <td>{{unit.delivery_by}}</td>
        </tr>
      </table>
      <pagination-controls (pageChange)="weeklySalesPageChangeEvent($event)" id="weekly_sales"></pagination-controls>
    </div>
  </div>
</div>
